import type { ConstructionTypeData } from 'gql/graphql';
import { BimEditOtherModal } from 'pages/Project/BimProject/BimCommonComponents/BimEditOtherModal';

import { useEditOtherData } from './hooks';

type TEditOtherProps = {
    isOpened: boolean;
    closeModalHandler: () => void;
    workOrderChangeOtherPriceId: number;
    workOrderOtherPriceId: number;
    constructionTypeId: number | undefined;
    refreshTable: () => void;
    constructionTypes: ConstructionTypeData[];
};

export const BimWorkOrderChangeEditOther = (props: TEditOtherProps) => {
    const {
        isOpened,
        constructionTypeId,
        closeModalHandler,
        workOrderChangeOtherPriceId,
        workOrderOtherPriceId,
        refreshTable,
        constructionTypes,
    } = props;

    const { otherData, isDataLoading, isUpdateInProgress, resetModalData, onSubmit } = useEditOtherData({
        workOrderChangeOtherPriceId,
        workOrderOtherPriceId,
        refreshTableData: refreshTable,
        isOpenModal: isOpened,
        constructionTypes,
    });

    return (
        <BimEditOtherModal
            otherData={otherData}
            onSubmit={onSubmit}
            onCloseModal={closeModalHandler}
            isDataLoading={isDataLoading}
            isUpdateInProgress={isUpdateInProgress}
            constructionTypeId={constructionTypeId}
            constructionTypes={constructionTypes}
            resetOtherData={resetModalData}
            forceUseRationaleField
        />
    );
};

BimWorkOrderChangeEditOther.displayName = 'BimWorkOrderChangeEditOther';
